// @ts-expect-error vite-plugin-pwa provides this virtual module at build time.
import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Owns the vite-plugin-pwa service-worker registration for the clinic app
 * (the `virtual:pwa-register/react` module only exists when VitePWA is enabled
 * in this app's Vite config).
 *
 * The app uses `registerType: 'autoUpdate'`, so vite-plugin-pwa activates a
 * newly-installed service worker immediately and reloads the page on its own —
 * there is no user-facing prompt and `needRefresh` never fires. This container
 * only needs to (a) trigger registration via the virtual module and (b) poll
 * for a new version every hour so long-lived tabs still pick up deploys.
 */
export function PwaUpdateContainer() {
  useRegisterSW({
    onRegisteredSW(_swUrl: string, r: ServiceWorkerRegistration | undefined) {
      // Periodic update check (every 30 min) for tabs that stay open.
      if (r) {
        setInterval(() => {
          r.update();
        }, 30 * 60 * 1000);
      }
    },
    onRegisterError(error: Error) {
      console.error('SW registration error', error);
    },
  });

  return null;
}
